import {
  AlertsManagementFilter,
  DropDownView,
  FilterType,
} from '@gripp/shared-ui';
import { View } from 'react-native';

interface AlertsManagementFilterMenuProps {
  isOpened: boolean;
  onFilterOpen: () => void;
  onFilterClose: () => void;
  anchorRef: React.RefObject<View>;
  type: FilterType;
}

export const AlertsManagementFilterMenu = ({
  isOpened,
  onFilterClose,
  anchorRef,
  type,
}: AlertsManagementFilterMenuProps) => {
  const isStatusFilter = type === FilterType.ALERTSMANAGEMENTSTATUS;

  return (
    <DropDownView
      anchorRef={anchorRef}
      isVisible={isOpened}
      onDismiss={onFilterClose}
      height={isStatusFilter ? 200 : 472}
      maxHeight={isStatusFilter ? 200 : 472}
    >
      <AlertsManagementFilter closeFilter={onFilterClose} type={type} />
    </DropDownView>
  );
};
